// extracted by mini-css-extract-plugin
export default {"circular":"DocumentDownload_circular__iIRzK"};